import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { WeightAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-weight-slot',
    templateUrl: './weight-slot.component.html',
    styleUrl: './weight-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeightSlotComponent implements SheetSlotComponentBase {

	action!: WeightAction;
	value!: string | null;

	@Input('action') set updateAction(action: WeightAction | null) {
		this.action = action as WeightAction;
		this.value = this.action.weight?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}